import _taggedTemplateLiteral from "/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import { css, createGlobalStyle } from 'styled-components';
import * as palette from '@accesa/styleguide/dist/_palette.css';
export var RootVariables = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", ";\n"])), palette);
export var GlobalStyles = createGlobalStyle(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n"])), RootVariables);